import React from "react";
import { ArrowUpRight, Building2, Spade, UtensilsCrossed } from "lucide-react";

const projects = [
  {
    name: "Scally Design & Construct",
    domain: "scallydesignconstruct.com",
    href: "https://scallydesignconstruct.com",
    discipline: "Design–Build Construction",
    description:
      "A refined digital presence for a premier design–build firm — presenting architectural work with the gravity and polish it deserves.",
    Icon: Building2,
  },
  {
    name: "Count Your Cards",
    domain: "countyourcards.com",
    href: "https://countyourcards.com",
    discipline: "Interactive Gaming",
    description:
      "A precision card-counting trainer that turns advantage play into an art form — fast, elegant, and built for mastery.",
    Icon: Spade,
  },
  {
    name: "Meus Menu",
    domain: "meusmenu.com",
    href: "https://meusmenu.com",
    discipline: "Hospitality Platform",
    description:
      "A digital menu platform for restaurateurs who sweat the details — every dish presented like it belongs on the table.",
    Icon: UtensilsCrossed,
  },
];

const Work = () => {
  return (
    <section id="work" className="mx-auto max-w-6xl px-6 py-20 sm:py-28 lg:py-36">
      <p className="text-xs font-light tracking-luxe uppercase text-gold">
        Selected Work
      </p>
      <h2 className="mt-6 max-w-2xl font-display text-3xl font-medium leading-tight sm:text-5xl">
        A portfolio measured in quality, not quantity.
      </h2>
      <div className="mt-16 grid gap-px overflow-hidden border border-white/10 bg-white/10 lg:grid-cols-3">
        {projects.map(({ name, domain, href, discipline, description, Icon }) => (
          <a
            key={domain}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative flex flex-col bg-onyx p-8 transition-colors duration-500 hover:bg-graphite sm:p-10"
          >
            <div className="flex items-start justify-between">
              <Icon
                size={28}
                strokeWidth={1.25}
                className="text-gold transition-transform duration-500 group-hover:scale-110"
              />
              <ArrowUpRight
                size={18}
                strokeWidth={1.25}
                className="text-stone transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-gold"
              />
            </div>
            <p className="mt-10 text-[0.65rem] font-light tracking-[0.22em] uppercase text-stone">
              {discipline}
            </p>
            <h3 className="mt-3 font-display text-2xl font-medium text-ivory">
              {name}
            </h3>
            <p className="mt-4 flex-1 text-sm font-light leading-relaxed text-stone">
              {description}
            </p>
            <p className="mt-8 text-xs font-light tracking-[0.15em] text-gold/80">
              {domain}
            </p>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Work;
